import toast from "react-hot-toast"

class Notify {
    success(msg: string) {
        toast.success(msg)
    }
    error(msg: string) {
        toast.error(msg)
    }
}

export default new Notify()